(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-snooker/assets/javascripts/init-box.js') >= 0) return;  svs.modules.push('/components/themes/sport-snooker/assets/javascripts/init-box.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_snooker = svs.themes.sport_snooker || {};

  svs.themes.sport_snooker.initStatusStart = function (data) {
    if (svs.themes.sport_snooker.isLive(data.status.id)) {
      if (data.status.id > 64 && data.status.id < 102) {
        return "<div class=\"brick match-status brick-active f-condensed align-center\">FRA ".concat(data.status.id - 64, "</div>");
      } 


      if (data.status.id === 14) {
        return '<div class="brick match-status brick-active f-condensed align-center">PAUS</div>';
      }

      return '';
    } else if (svs.themes.sport_snooker.isEnded(data.status.id)) {
      if (data.status.id === 25) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">INST</div>';
      } 


      if (data.status.id === 28) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">UPPH</div>';
      } 


      if (data.status.id === 29 || data.status.id === 116 || data.status.id === 117 || data.status.id === 120 || data.status.id === 121) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">SLUT</div>';
      } 


      if (data.status.id === 26 || data.status.id === 30 || data.status.id === 118 || data.status.id === 119) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">AVBR</div>';
      }

      return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">SLUT</div>';
    } else if (data.startTime) {
      return "<div class=\"brick match-status brick-border f-condensed align-center\">".concat(svs.themes.formatTime(data.startTime), "</div>");
    }

    return '';
  };


  svs.themes.sport_snooker.hasMatchMinutes = function () {
    return false;
  };
})(svs);
 })(window);